// extracted by mini-css-extract-plugin
export default {"item":"ofx6G","item--cb":"ULZUk","title":"cr8KS","checkbox_text":"vYRTu","checkbox":"WAWaX","error":"KGTiM"};